// based on rc-tree 1.14.9
'use strict';

module.exports = require('./src/');
